import React, { useState, useEffect } from "react";
import Profile from "../components/Profile";
import Profile2 from "../components/Profile2";
import { Button } from "@mui/material";
import api from "../utils/api";
import dayjs from "dayjs";
import axios from "axios";
import Swal from "sweetalert2";
export const commonStyles = {
  width: "100%",
  "& .MuiInputBase-input": {
    color: "#0F0E0E",
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "6px",
    "&.Mui-focused fieldset": {
      borderColor: "#1b7870",
    },
    "&.Mui-error fieldset": {
      borderColor: "#fc4747",
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#ADADAD",
  },
  "& .MuiFormLabel-root": {
    color: "black",
  },
};

const ProfilePage = ({pensionPolicies}) => {
  const [data, setData] = useState(null);
  const [formValues, setFormValues] = useState({
    full_name: "",
    issueDate: dayjs("2023-01-01"),
    email: "",
    idNumber: "",
    birthDate: dayjs("2023-01-01"),
    phone_number: "",
    do_you_smoke: "כן",
    chronic_illness: "כן",
    medical_examination: "כן",
    signature: "",
    profile_picture: "",
  });
  const [originalUserData, setOriginalUserData] = useState({
    idNumber: "",
    birthDate: null,
    issueDate: null,
  });
  const [profile_picture_db, Setprofile_picture_db] = useState('')
  const [userIDNum, SetuserIDNum] = useState('')

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get(
          `${process.env.REACT_APP_BE_BASE_URL}user/get_user`
        );
        setData(response.data.data);
        const userData = response.data.data;
        Setprofile_picture_db(userData.profile_picture)
        SetuserIDNum(userData.idNumber)
        setFormValues({
          full_name: userData.full_name || "",
          issueDate: userData.issueDate
            ? dayjs(userData.issueDate)
            : dayjs("2023-01-01"),
          email: userData.email || "",
          idNumber: userData.idNumber || "",
          birthDate: userData.birthDate
            ? dayjs(userData.birthDate)
            : dayjs("2023-01-01"),
          phone_number: userData.phone_number || "",
          do_you_smoke: userData.do_you_smoke || "כן",
          chronic_illness: userData.chronic_illness || "כן",
          medical_examination: userData.medical_examination || "כן",
          signature: userData.signature || "",
          profile_picture: userData.profile_picture || "",
        });
        setOriginalUserData({
          idNumber: userData.idNumber || "",
          birthDate: userData.birthDate ? dayjs(userData.birthDate) : dayjs("2023-01-01"),
          issueDate: userData.issueDate ? dayjs(userData.issueDate) : dayjs("2023-01-01"),
        });
      } catch (err) {
        console.log("Failed to fetch data", err);
      }
    };
    fetchData();
  }, []);
  const [loading, setLoading] = useState(false)
  const updateUserProfile = async () => {
    try {
      setLoading(true)
      const formattedFormValues = {
        ...formValues,
        issueDate: dayjs(formValues.issueDate).format("YYYY-MM-DD"),
        birthDate: dayjs(formValues.birthDate).format("YYYY-MM-DD"),
      };
      const response = await api.post(
        `${process.env.REACT_APP_BE_BASE_URL}user/user_update`,
        formattedFormValues
      );
      
      if (response.status === 200) {
        const idChanged = formValues.idNumber !== originalUserData.idNumber;
        const birthChanged = !dayjs(formValues.birthDate).isSame(originalUserData.birthDate, "day");
        const issueChanged = !dayjs(formValues.issueDate).isSame(originalUserData.issueDate, "day");
  
        if (idChanged || birthChanged || issueChanged) {
          checkUserDetails();
        }
        Swal.fire({
          title: "הפרופיל עודכן!",
          text: "הפרופיל שלך עודכן בהצלחה.",
          icon: "success",
          confirmButtonText: "בסדר",
        });
        Setprofile_picture_db(formValues.profile_picture)
        SetuserIDNum(formValues.idNumber)
        setOriginalUserData({
          idNumber: formValues.idNumber || "",
          birthDate: formValues.birthDate || null,
          issueDate: formValues.issueDate || null,
        });
      } else {
        Swal.fire({
          title: "עדכון נכשל!",
          text: "לא ניתן היה לעדכן את הפרופיל. נסה שוב מאוחר יותר.",
          icon: "error",
          confirmButtonText: "אישור",
        });
      }
      setLoading(false)
    } catch (err) {
      setLoading(false)
      console.log(err);
    }
  };

  const checkUserDetails = async () => {
    if (
      formValues.idNumber &&
      formValues.birthDate &&
      formValues.issueDate
    ) {
      try {
        if (!data.insurance_status) {
          const insurance = await axios.post(
          "https://f3fxrg0gd3.execute-api.eu-central-1.amazonaws.com/get_insurance",
          {
            idNumber: formValues.idNumber,
            full_name: formValues.full_name,
            birthDate: dayjs(formValues.birthDate.$d || formValues.birthDate).format("DD/MM/YYYY"),
            issueDate: dayjs(formValues.issueDate.$d || formValues.issueDate).format("DD/MM/YYYY"),
          },
          {
            headers: {
              "X-API-Key": "e0c43d33657138baebe70ec851cafd6786758280c7c79e2ff653c54a5b8ab32a",
              Authorization: "Basic cHJvZHVjdGl2ZUBwcm9maW5ibWMuY29tOkJNQzIwMjUhcHJvZmluIUBAQA==",
            },
          }
        );
        }
        
      } catch (error) {
        console.error("Insurance API failed:", error);
      }
  
      try {
        console.log('pensionPolicies', pensionPolicies);
        if (!pensionPolicies?.length && !data.pension_status) {
          const pension = await axios.post(
            "https://zco3myjcyc.execute-api.eu-central-1.amazonaws.com/get_pension",
            {
            idNumber: formValues.idNumber,
            full_name: formValues.full_name,
            birthDate: dayjs(formValues.birthDate.$d || formValues.birthDate).format("DD/MM/YYYY"),
            issueDate: dayjs(formValues.issueDate.$d || formValues.issueDate).format("DD/MM/YYYY"),
          },
          );
        }
        
      } catch (error) {
        console.error("Pension API failed:", error);
      }
    }
  };
 
  return (
    <div>
      <Profile
        commonStyles={commonStyles}
        setFormValues={setFormValues}
        formValues={formValues}
        userIDNum={userIDNum}
      />
      <Profile2
        commonStyles={commonStyles}
        setFormValues={setFormValues}
        formValues={formValues}
        profile_picture_db={profile_picture_db}
      />
      <Button
        onClick={updateUserProfile}
        style={{ padding: "9px 15px", width: "max-content" }}
        className="btn"
        size="medium"
        variant="contained"
      >
       {loading ? "חיסכון..." : "לעדכון נתונים"}
      </Button>
    </div>
  );
};

export default ProfilePage;
